module.exports = __webpack_public_path__ + "static/media/p2.dc410e8c.jpg";